(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const beforeBtn = document.querySelector('.ba-toggle-before');
  const afterBtn = document.querySelector('.ba-toggle-after');
  const beforeBlock = document.querySelector('.ba-toggle-before-block');
  const afterBlock = document.querySelector('.ba-toggle-after-block');
  const headings = document.querySelectorAll('.ba-heading');

  headings.forEach(el => {
    const words = el.dataset.heading.trim().split(" ");
    el.innerHTML = words.map(word => `<span>${word}</span>`).join(" ");
  });

  beforeBtn.addEventListener("click", function () {
    beforeBlock.classList.add("active");
    afterBlock.classList.remove("active");
    beforeBtn.classList.add("active");
    afterBtn.classList.remove("active");
  });

  afterBtn.addEventListener("click", function () {
    afterBlock.classList.add("active");
    beforeBlock.classList.remove("active");
    afterBtn.classList.add("active");
    beforeBtn.classList.remove("active");
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["careers-form"] && !Shopify.designMode) return;
  try {
    


document.addEventListener('DOMContentLoaded', () => {

   async function sendforminfo(orderCode, type) {
    const loader = document.getElementById("loader");
    loader.style.display = "block";

    try {
      const url = `https://iwebcluedev.in/karban/api/support.php`;
      const response = await fetch(url);
      loader.style.display = "none";
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
    } catch (err) {
      loader.style.display = "none";
      console.error("❌ Error fetching tracking info:", err);
      alert("Check console for details.");
    }
  }
  
document.getElementById("support-ajax-form").addEventListener("submit", async (e) => {
  e.preventDefault();

  

  // Clear previous error messages
  document.querySelectorAll(".error-message").forEach(el => el.textContent = "");

  // Collect form data
  const full_name = document.getElementById("full_name").value.trim();
  const phone = document.getElementById("phone").value.trim();
  const product = document.getElementById("product").value.trim();
  const subject = document.getElementById("subject").value.trim();
  const message = document.getElementById("support_message").value.trim();
  const invoiceno = document.getElementById("invoiceno").value.trim();
  const priority = document.getElementById("priority").value.trim();
  // const captchaAnswer = captchaInput.getAttribute("data-answer");
  
  let hasError = false;

  // Validation rules
  if (!full_name) {
    document.querySelector('[data-err="name"]').textContent = "Please enter your full name.";
    hasError = true;
  }
  if (!phone) {
    document.querySelector('[data-err="phone"]').textContent = "Please enter your phone number.";
    hasError = true;
  }
  if (!product) {
    document.querySelector('[data-err="product"]').textContent = "Please enter product name.";
    hasError = true;
  }
  if (!subject) {
    document.querySelector('[data-err="subject"]').textContent = "Please enter subject.";
    hasError = true;
  }
  if (!message) {
    document.querySelector('[data-err="message"]').textContent = "Please describe your issue.";
    hasError = true;
  }
  if (!invoiceno) {
    document.querySelector('[data-err="invoiceno"]').textContent = "Please enter invoice number.";
    hasError = true;
  }
  if (!priority) {
    document.querySelector('[data-err="priority"]').textContent = "Please select priority.";
    hasError = true;
  }
  // if (captchaValue !== captchaAnswer) {
  //   document.querySelector('[data-err="captcha"]').textContent = "Captcha answer is incorrect.";
  //   hasError = true;
  // }

  // Stop submission if any error found
  if (hasError) {
    loader.style.display = "none";
    return;
  }

  // Prepare data for sending
  const formData = {
    full_name,
    phone,
    product,
    subject,
    message,
    invoiceno,
    priority
  };

  try {
    const response = await fetch("https://iwebcluedev.in/karban/api/support.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData)
    });

    loader.style.display = "none";

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const result = await response.json();

    // show success
    document.querySelector(".form-success-message").style.display = "block";
     setTimeout(() => {
       document.querySelector(".form-success-message").style.display = "none";
    }, 5000);

    // reset form
    document.getElementById("support-ajax-form").reset();
  } catch (err) {
    loader.style.display = "none";
    console.error("❌ Error:", err);
    document.querySelector('[data-err="subject"]').textContent = "Something went wrong. Please try again later.";
  }
});

  const form        = document.querySelector('.support-ajax-formi');
  const successBox  = form.querySelector('.form-success-message');
  // const captchaIn   = form.querySelector('.captcha-input');
  const reloadBtn   = form.querySelector('.reload-captcha');
  const invoiceIn   = form.querySelector('input[name="invoice"]');

  /* Setup Uploadcare widget */
  let invoiceFilename = '';
  const ucWidget = uploadcare.Widget(invoiceIn);
  ucWidget.onUploadComplete(info => { invoiceFilename = info.name || ''; });

  /* --------- Captcha helpers --------- */
  const newCaptcha = () => {
    const a = Math.floor(Math.random()*10)+1;
    const b = Math.floor(Math.random()*10)+1;
    captchaIn.placeholder  = `What is ${a} + ${b}?`;
    captchaIn.dataset.answer = a + b;
    captchaIn.value = '';
  };
  newCaptcha();
  reloadBtn.addEventListener('click', e => { e.preventDefault(); newCaptcha(); });

  /* --------- validation + AJAX --------- */
  const clearErrors = () => form.querySelectorAll('.error-message').forEach(e => e.textContent='');

  form.addEventListener('submit', async e => {
    e.preventDefault();
    clearErrors();
    let valid = true;
    const get = n => form.querySelector(`[name="${n}"]`).value.trim();

    // Name
    if(!/^[A-Za-z\s]{3,}$/.test(get('full_name'))){
      form.querySelector('[data-err="name"]').textContent="Enter Full Name";
      valid=false;
    }
    // Phone
    if(!/^\d{10}$/.test(get('phone'))){
      form.querySelector('[data-err="phone"]').textContent="Enter 10‑digit phone";
      valid=false;
    }
    // Product
    if(!get('product')){
      form.querySelector('[data-err="product"]').textContent="Product name is required";
      valid=false;
    }
    // Subject
    if(!get('subject')){
      form.querySelector('[data-err="subject"]').textContent="Subject is required";
      valid=false;
    }
    // Message
    if(!get('message')){
      form.querySelector('[data-err="message"]').textContent="Message cannot be empty";
      valid=false;
    }
    // Invoice (just check something uploaded)
    if(!invoiceIn.value){
      form.querySelector('[data-err="invoice"]').textContent="Please upload the invoice file";
      valid=false;
    }
    // Captcha
    if(get('captcha') === ''){
      form.querySelector('[data-err="captcha"]').textContent="Answer captcha";
      valid=false;
    }else if(parseInt(get('captcha')) !== parseInt(captchaIn.dataset.answer)){
      form.querySelector('[data-err="captcha"]').textContent="Incorrect captcha";
      valid=false;
      newCaptcha();
    }
    // Priority
    if(get('priority') === ''){
      form.querySelector('[data-err="priority"]').textContent="Select priority";
      valid=false;
    }

    if(!valid) return;

    /* --------- send to Formspree --------- */
    const fd = new FormData(form);
    try{
      const res = await fetch(form.action, {
        method:'POST',
        body:fd,
        headers:{ 'Accept':'application/json' }
      });
      if(res.ok){
        successBox.style.display='block';
        form.reset();
        invoiceFilename = '';
        newCaptcha();
      }else{
        alert('Something went wrong. Please try again later.');
      }
    }catch(err){
      console.error(err);
      alert('Failed to submit. Check your connection.');
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collaboration-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  const form = document.getElementById('collab-form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const loader = document.getElementById('loader');
    const success = document.querySelector('.success-msg');

    loader.style.display = 'block';

    const fd = new FormData(form);
    fd.append('form_type', 'collaboration');

    try {
      await fetch('https://script.google.com/macros/s/AKfycbwdmIARcXZqU0i17B4sPLrIXaqS4QIYy9bnoNWuH1wNAyba09uLDNkkELUZdLNn9LvkBA/exec', {
        method: 'POST',
        body: fd
      });

      loader.style.display = 'none';
      success.style.display = 'block';
      form.reset();

    } catch (err) {
      loader.style.display = 'none';
      alert('Something went wrong');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-map-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const mapFrame = document.getElementById('map-frame');
    const storeDropdown = document.getElementById('store-dropdown');
    const dealerDropdown = document.getElementById('dealer-dropdown');
    const contactForm = document.getElementById('custom-contact-form');
    const submitBtn = document.getElementById('contact-submit-btn');
    const successMsg = document.getElementById('contact-success');

    function updateMap(location) {
      const query = encodeURIComponent(location);
      mapFrame.src = `https://maps.google.com/maps?q=${query}&z=13&output=embed`;
    }

    if (storeDropdown) {
      storeDropdown.addEventListener('change', function () {
        updateMap(this.value);

        if (dealerDropdown) {
          dealerDropdown.selectedIndex = 0;
        }
      });
    }

    if (dealerDropdown) {
      dealerDropdown.addEventListener('change', function () {
        updateMap(this.value);

        if (storeDropdown) {
          storeDropdown.selectedIndex = 0;
        }
      });
    }

    if (contactForm) {
      contactForm.addEventListener('submit', async function (e) {
        e.preventDefault();

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.innerText = 'Submitting...';
        }

        if (successMsg) {
          successMsg.style.display = 'none';
        }

        const fd = new FormData();

        fd.append('form_type', 'Contact Us');
        fd.append('name', document.querySelector('[name="contact[name]"]').value);
        fd.append('email', document.querySelector('[name="contact[email]"]').value);
        fd.append('phone', document.querySelector('[name="contact[phone]"]').value);
        fd.append('message', document.querySelector('[name="contact[body]"]').value);
        fd.append('page_url', window.location.href);

        try {
          const response = await fetch(
            'https://script.google.com/macros/s/AKfycbwdmIARcXZqU0i17B4sPLrIXaqS4QIYy9bnoNWuH1wNAyba09uLDNkkELUZdLNn9LvkBA/exec',
            {
              method: 'POST',
              body: fd,
            }
          );

          if (!response.ok) {
            throw new Error('Server Error');
          }

          contactForm.reset();

          if (successMsg) {
            successMsg.style.display = 'block';
          }
        } catch (err) {
          console.error(err);
          alert('Something went wrong. Please try again.');
        } finally {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerText = 'Submit';
          }
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customLandingNavbar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const links = Array.from(document.querySelectorAll('#landing-navbar .landing-link'));
    const sections = links
      .map((link) => {
        const id = link.getAttribute('href').slice(1);
        return document.getElementById(id);
      })
      .filter(Boolean);

    const navH = document.querySelector('#landing-navbar')?.offsetHeight || 80;

    if (links.length > 0) links[0].classList.add('active');

    links.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const id = link.getAttribute('href').slice(1);
        const el = document.getElementById(id);
        if (el) {
          window.scrollTo({
            top: el.getBoundingClientRect().top + window.scrollY - navH,
            behavior: 'smooth',
          });
        }
      });
    });

    const setActive = () => {
      const scrollPos = window.scrollY + navH + 10;
      let current = null;

      sections.forEach((section) => {
        if (section.offsetTop <= scrollPos) current = section;
      });

      links.forEach((link) => {
        link.classList.toggle('active', current && link.getAttribute('href').slice(1) === current.id);
      });
    };

    var navTicking = false;
    document.addEventListener(
      'scroll',
      function () {
        if (!navTicking) {
          navTicking = true;
          requestAnimationFrame(function () {
            setActive();
            navTicking = false;
          });
        }
      },
      { passive: true }
    );
    setActive();

    document.querySelectorAll('[data-add-to-cart]').forEach((btn) => {
      btn.addEventListener('click', () => {
        let variantId = null;

        // ✅ Get from product form (dynamic)
        const form = document.querySelector('form[action*="/cart/add"]');
        if (form) {
          const input = form.querySelector('[name="id"]');
          if (input) {
            variantId = input.value;
          }
        }

        // fallback
        if (!variantId && window.Shopify && ShopifyAnalytics?.meta?.selectedVariantId) {
          variantId = ShopifyAnalytics.meta.selectedVariantId;
        }

        if (!variantId) {
          alert('Please select a variant');
          return;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        })
          .then(() => (window.location.href = '/cart'))
          .catch(() => alert('Could not add to cart'));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-futuristic"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector(".futuristic-hero-section");
  const textLines = [
    document.querySelector(".line-one"),
    document.querySelector(".line-two"),
    document.querySelector(".line-three"),
    document.querySelector(".line-four"),
  ];

  localStorage.removeItem("futuristicScrollColorPlayed");

  textLines.forEach(line => {
    gsap.set(line, { opacity: 0.2, color: "#1F1F1F" });
  });

  const scrollTimeline = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top top",
      end: "+=100",
      scrub: 0.1,
      pin: false,
      pinSpacing: true      
    }
  });

  scrollTimeline
     .to(textLines, { opacity: 1, duration: 0.2, stagger: 0.05 });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inquiries-form-section"] && !Shopify.designMode) return;
  try {
    
(function(){

const form=document.getElementById("support-ajax-form");
if(!form) return;

form.addEventListener("submit",async(e)=>{
e.preventDefault();

const loader=document.getElementById("loader");
loader.style.display="block";

document.querySelectorAll(".error-message").forEach(e=>e.textContent="");

const full=document.getElementById("full_name").value.trim();
const company=document.getElementById("companyname").value.trim();
const phone=document.getElementById("phone").value.trim();
const city=document.getElementById("city").value.trim();
const product=document.getElementById("product").value;
const gst=document.getElementById("gst").value.trim();
const msg=document.getElementById("support_message").value.trim();
const card=document.getElementById("businesscard").files[0];

let err=false;

if(!full){document.querySelector('[data-err="name"]').textContent="Required";err=true;}
if(!phone){document.querySelector('[data-err="phone"]').textContent="Required";err=true;}
if(!product){document.querySelector('[data-err="product"]').textContent="Required";err=true;}
if(!msg){document.querySelector('[data-err="message"]').textContent="Required";err=true;}
if(!card){document.querySelector('[data-err="businesscard"]').textContent="Required";err=true;}

if(err){loader.style.display="none";return;}

const fd=new FormData();
fd.append("form_type","b2b");

fd.append("full_name",full);
fd.append("company",company);
fd.append("phone",phone);
fd.append("city",city);
fd.append("product",product);
fd.append("gst",gst);
fd.append("message",msg);

const toBase64 = f => new Promise(res=>{
 const r=new FileReader();
 r.onload=()=>res(r.result);
 r.readAsDataURL(f);
});

const base64 = await toBase64(card);

fd.append("file", base64);



try{
 const r = await fetch("https://script.google.com/macros/s/AKfycbwdmIARcXZqU0i17B4sPLrIXaqS4QIYy9bnoNWuH1wNAyba09uLDNkkELUZdLNn9LvkBA/exec", {
  method: "POST",
  body: fd
});


 if(!r.ok) throw "server";

 loader.style.display="none";
 document.querySelector(".form-success-message").style.display="block";
 form.reset();

}catch(e){
 loader.style.display="none";
 alert("Server error");
}

});

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
  const form = document.getElementById('support-ajax-form');
  if (!form) return;

  let isSubmitting = false; 

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    if (isSubmitting) return; 
    isSubmitting = true;

    const submitBtn = form.querySelector('button[type="submit"]');
    const loader = document.getElementById('loader');

    submitBtn.disabled = true; 
    submitBtn.innerText = "Submitting...";
    loader.style.display = 'block';

    const fd = new FormData(form);
    fd.append('form_type', 'support');

    try {
      await fetch(
        'https://script.google.com/macros/s/AKfycbwdmIARcXZqU0i17B4sPLrIXaqS4QIYy9bnoNWuH1wNAyba09uLDNkkELUZdLNn9LvkBA/exec',
        {
          method: 'POST',
          body: fd,
        }
      );

      loader.style.display = 'none';
      document.querySelector('.form-success-message').style.display = 'block';
      karbanLead('support', { name: fd.get('full_name'), phone: fd.get('phone') });
      form.reset();

    } catch (e) {
      loader.style.display = 'none';
      alert('Server error');

      // 🔁 allow retry if failed
      submitBtn.disabled = false;
      submitBtn.innerText = "Submit";
      isSubmitting = false;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-media-gallery"] && !Shopify.designMode) return;
  try {
    
function initTabbedMediaGallery(sectionId) {
  const sectionEl = document.querySelector(`[data-section-id="${sectionId}"]`);
  if (!sectionEl) return;

  // Desktop Tabs
  const tabButtons = sectionEl.querySelectorAll('.tm-tabs .tm-tab-button');
  const tabPanes = sectionEl.querySelectorAll('.tm-tab-content .tm-tab-pane');

  tabButtons.forEach((btn, i) => {
    btn.addEventListener('click', () => {
      console.log('Tab button clicked:', i);
      tabButtons.forEach(b => b.classList.remove('active'));
      tabPanes.forEach(p => p.classList.remove('active'));

      btn.classList.add('active');
      tabPanes[i].classList.add('active');

      const media = tabPanes[i].querySelector('.tm-tab-image, .tm-tab-video');
      if (media) {
        media.classList.remove('tm-tab-media-animate');
        void media.offsetWidth;
        media.classList.add('tm-tab-media-animate');
      }
    });
  });

  // Mobile Tabs
  let currentIndex = 0;
  const mobilePanes = sectionEl.querySelectorAll('.tm-mobile-tab-content .tm-tab-pane');
  const prevBtn = sectionEl.querySelector(`#tm-prev-tab-${sectionId}`);
  const nextBtn = sectionEl.querySelector(`#tm-next-tab-${sectionId}`);

  function updateMobileTabs(index) {
    mobilePanes.forEach((pane, i) => {
      pane.classList.toggle('active', i === index);
      if (i === index) {
        const media = pane.querySelector('.tm-tab-image, .tm-tab-video');
        if (media) {
          media.classList.remove('tm-tab-media-animate');
          void media.offsetWidth;
          media.classList.add('tm-tab-media-animate');
        }
      }
    });
  }

  if (prevBtn && nextBtn) {
    prevBtn.addEventListener('click', () => {
      currentIndex = (currentIndex - 1 + mobilePanes.length) % mobilePanes.length;
      console.log('Previous button clicked, current index:', currentIndex);
      updateMobileTabs(currentIndex);
    });

    nextBtn.addEventListener('click', () => {
      currentIndex = (currentIndex + 1) % mobilePanes.length;
      console.log('Next button clicked, current index:', currentIndex);
      updateMobileTabs(currentIndex);
    });
  }

  updateMobileTabs(currentIndex);
}

// On first load
document.addEventListener('DOMContentLoaded', function () {
  initTabbedMediaGallery('{{ section.id }}');
});

// Re-initialize after section reload (important for Shopify theme editor)
document.addEventListener('shopify:section:load', function (event) {
  if (event.detail.sectionId === '{{ section.id }}') {
    initTabbedMediaGallery('{{ section.id }}');
  }
});


  } catch(e) { console.error(e); }
})();
})();
